export const getUtagData = () => window.utag_data ?? {};

export const getUtagDataChatConfig = () =>
  getUtagData().hsbc_chat_assistant_config ?? {};
